import featureFlags from './featureFlags.json';

const ft = (key, flagsToCheck = []) => {
  const feature = featureFlags[key];
  
  if (!feature) return false;
  if (flagsToCheck.includes(null)) return false;

  if (feature.preRequisite) {
    const prerequisiteEnabled = ft(feature.preRequisite, flagsToCheck);
    if (!prerequisiteEnabled) return false;
  }

  const isFeatureEnabled = feature.enabled === true;

  if (flagsToCheck.length > 0) {
    for (let flag of flagsToCheck) {
      const flagFeature = featureFlags[flag];
      if (!flagFeature || !ft(flag, [])) return false;
    }
  }

  return isFeatureEnabled;
};

const gft = (routeName) => {
  for (const key in featureFlags) {
    if (featureFlags[key].routeName === routeName) {
      return key;
    }
  }
  return null;
};

export { ft, gft, featureFlags };
